import { createSelector } from '@reduxjs/toolkit';
import { computersForMap } from './computers-for-map';

export const standaloneComputers = createSelector(computersForMap, (computers) => {
  return computers.filter(function (c) {
    return c.unitType === 'computer' && !c.networkUuid;
  });
});
